/* global axios */

import CacheEnabledApiClient from './CacheEnabledApiClient';

// custom_role_ids and blob_ids are not ActiveRecord attributes, so Rails'
// ParamsWrapper would drop them from a flat payload. Nesting the wrapper
// ourselves keeps them intact.
const buildPayload = attributes => ({ canned_response: attributes });

class CannedResponse extends CacheEnabledApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'canned_response';
  }

  // The index endpoint returns a bare array instead of a payload wrapper
  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: dataToParse };
  }

  create(payload) {
    return axios.post(this.url, buildPayload(payload));
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, buildPayload(payload));
  }
}

export default new CannedResponse();
